import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class MatrixLite {
businessUnitCode: string;
code: string;
columns: Object;
description: TranslatedEmb;
domain: string;
id: number | null;
label: TranslatedEmb;
rowCount: number | null;
shortCode: string;
}

